const RightQuick = () => {
  return (
    <div className="hidden fixed bottom-10 right-0 z-50 px-5 w-72 lg:flex gap-3">
      <button
        type="button"
        onClick={() => window.open("https://blog.naver.com/allin2sj")}
        className="transition hover:scale-[1.02] active:scale-[0.98]"
      >
        <img
          src="/images/iconNaver.png"
          alt="네이버 블로그 바로가기"
          className="!relative w-auto h-full max-h-16 object-contain"
        />
      </button>
      <button
        type="button"
        onClick={() => window.open("https://open.kakao.com/o/sqqi7Cvi")}
        className="transition hover:scale-[1.02] active:scale-[0.98]"
      >
        <img
          src="/images/iconKakao.png"
          alt="카카오톡 상담 바로가기"
          className="!relative w-auto h-full max-h-16 object-contain"
        />
      </button>
    </div>
  );
};

export default RightQuick;
